// React 19 hoists <title>/<meta>/<link> rendered in components into <head>
// automatically — no Helmet needed. The <html lang> is set in index.html.

const title = 'Vértice - Open Finance Brasil';
const description = 'Controle suas finanças conectando suas contas bancárias via Open Finance';
const image = '/link-assets.png';

export function AppHead() {
  const canonicalUrl = typeof window !== 'undefined' ? window.location.href : '/';

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="theme-color" content="#10b981" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Vértice" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
}
